<template>
    <li class="sportsSwitch-sportItem sportsSwitch-sportsCup">
        <div
            class="sportsSwitch-sportsCup-background SportList_Btn_Euro2024"
        >
            <img
                class="sportsSwitch-sportsCup-icon"
                src="@/assets/images/sports-cup/sports_cup_icon.png"
                alt=""
                aria-hidden="true"
            >
            <span>{{ i18n.t('sportsCupZone_title') }}</span>
            <img
                class="sportsSwitch-sportsCup-arrow"
                src="@/assets/images/sports-cup/arrow-forward.svg"
                alt=""
                aria-hidden="true"
            >
        </div>
    </li>
</template>

<script lang="ts" setup>
    import { i18n } from '@/libraries/i18n';
</script>

<style lang="scss" scoped>
.sportsSwitch-sportsCup {
    padding: 1rem;

    &-background {
        display: flex;
        width: calc(100% - 3px);
        height: 3rem;
        align-items: center;
        padding-right: 1.2rem;
        background-image: url("../../assets/images/sports-cup/bg_sports_cup.png");
        background-size: 100% 100%;
        border-radius: 5px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 25%);
        color: #000000;
        font-family: Roboto, sans-serif;
        font-size: 12px;
        font-weight: 700;
    }

    &-icon {
        height: 100%;
        border-radius: 0.5rem;
    }

    &-arrow {
        margin-left: auto;
        animation-direction: alternate;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-name: move;
        animation-timing-function: linear;
    }

    @keyframes move {
        from {
            transform: translateX(0%);
        }

        to {
            transform: translateX(-50%);
        }
    }
}
</style>
